import React from "react";
import CodePage from "~/components/login/CodePage";
import PersonalInformationPage from "~/components/login/PersonalInformationPage";
import TelephonePage from "~/components/login/TelephonePage";
import EmailSignUp from "~/components/login/EmailSignUp";
import EmailSignIn from "~/components/login/EmailSignIn";
import CheckoutPage from "~/views/checkoutPage";
import CheckoutDeepLinkPage from "~/views/checkoutDeepLinkPage";
import NotFound from "~/views/notFound/NotFound";
import AppAccessPage from "~/views/schedulingApp/AppAccess";
import ConfirmationPage from "~/views/schedulingConfirmation/SchedulingConfirmation";
import SelectScheduleDate from "~/views/selectScheduleDate/SelectScheduleDate";
import SelectScheduleTime from "~/views/selectScheduleTime/SelectScheduleTime";
import ServiceScheduling from "~/views/ServiceScheduling";
import VendorPage from "~/views/vendorPage/VendorPage";
import Indications from "~/views/indications/Indications";
import BookingScreen from "~/views/bookingScreen/BookingScreen";
import Register from "~/views/registerPage";
import Notifications from "~/views/notificationsPage";
import RegisteredPet from "~/views/registeredPet";
import AddPet from "~/views/addPet";
import Coupon from "~/components/coupon";
import CategorieScheduling from "~/views/CategorieScheduling";
import YourEarnings from "~/views/indications/yourEarnings/YourEarnings";
import YourReferrals from "~/views/indications/yourReferrals/YourReferrals";
import HowIndicationsWork from "~/views/indications/howIndicationsWork/HowIndicationsWork";
import OptionsLogin from "~/components/login/optionsLogin";
import PersonalInformationNumber from "~/components/login/PersonalInformationNumber";
import CheckoutPackagePage from "~/views/checkoutPackagePage";
import BusinessPage from "~/views/business/BusinessPage";
import VendorPackages from "~/components/vendorPage/vendorPackages";
import ExpiredLink from "~/views/expiredLink/ExpiredLink";
import PackagePurchaseConfirmation from "~/components/confirmationPackage";
import AppointmentSummaryScreen from "~/views/appointmentSummary/AppointmentSummaryScreen";
import GoogleTranslateErrorBoundary from "~/components/common/GoogleTranslateErrorBoundary";
import BusinessProfilePage from "~/views/businessProfile";
import NoReservationsLink from "~/views/noReservationsLink/NoReservationsLink";
import LaterPaymentCheckoutPage from "~/views/laterPaymentCheckoutPage";
import BookingConfirmationScreen from "~/views/bookingConfirmation/BookingConfirmationScreen";

const routes = [
	{
		path: "/download/:id",
		exact: true,
		view: () => <AppAccessPage />,
		access: "public"
	},
	{
		path: "/perfil-business/:id",
		exact: true,
		view: () => <BusinessProfilePage />,
	},
	{
		path: "/endereco/:id",
		exact: true,
		view: () => <Register />,
		access: "public"
	},
	{
		path: "/business/link",
		exact: true,
		view: () => <BusinessPage />,
		access: "public"
	},
	{
		path: "/business/link/:id",
		exact: true,
		view: () => <BusinessPage />,
		access: "public"
	},
	{
		path: "/business/link/:id/:token",
		exact: true,
		view: () => <BusinessPage />,
		access: "public"
	},
	{
		path: "/business/:id",
		exact: true,
		view: () => <VendorPage />,
		access: "public"
	},
	{
		path: "/business/:id/:token",
		exact: true,
		view: () => <VendorPage />,
		access: "public"
	},
	{
		path: "/business/:id/code/:code",
		exact: true,
		view: () => <VendorPage />,
		access: "public"
	},
	{
		path: "/packages/:id",
		exact: true,
		view: () => <VendorPackages />,
		access: "public"
	},
	{
		path: "/reservas",
		exact: true,
		view: () => <BookingScreen />,
		access: "private"
	},
	{
		path: "/reservas",
		exact: true,
		view: () => <BookingScreen />,
	},
	{
		path: "/reservas/:id",
		exact: true,
		view: () => <BookingScreen />,
		access: "private"
	},
	{
		path: "/business/:id/bookingTransactionId/:bookingTransactionId",
		exact: true,
		view: () => <BookingScreen />,
		access: "private"
	},
	{
		path: "/selecionar-categoria/:id",
		exact: true,
		view: () => <CategorieScheduling />,
		access: "schedule"
	},
	{
		path: "/selecionar-servicos/:id",
		exact: true,
		view: () => <ServiceScheduling />,
		access: "schedule"
	},
	{
		path: "/notificacoes/:id",
		exact: true,
		view: () => <Notifications />,
		access: "private"
	},
	{
		path: "/notificacoes/:id/bookingTransactionId/:bookingTransactionId",
		exact: true,
		view: () => <Notifications />,
		access: "private"
	},
	{
		path: "/pets-cadastrados/:id",
		exact: true,
		view: () => <RegisteredPet />,
		access: "public"
	},
	{
		path: "/adicionar-pet/:id",
		exact: true,
		view: () => <AddPet />,
		access: "public"
	},
	{
		path: "/cupons/:id",
		exact: true,
		view: () => <Coupon />,
		access: "private"
	},
	{
		path: "/selecionar-data/:id",
		exact: true,
		view: () => <SelectScheduleDate />,
		access: "schedule"
	},
	{
		path: "/selecionar-horarios/:id",
		exact: true,
		view: () => <SelectScheduleTime />,
		access: "schedule"
	},
	{
		path: "/checkout/:id/bookingTransaction/:bookingTransactionId",
		exact: true,
		view: () => <CheckoutDeepLinkPage />,
		access: "public"
	},
	{
		path: "/later-payment/:id/bookingTransactionId/:bookingTransactionId",
		exact: true,
		view: () => <LaterPaymentCheckoutPage />,
		access: "public"
	},
	{
		path: "/booking-confirmation",
		exact: true,
		view: () => <BookingConfirmationScreen />,
		access: "public"
	},
	{
		path: "/checkout/:id",
		exact: true,
		view: () => <CheckoutPage />,
		access: "public"
	},
	{
		path: "/checkout-package/:id",
		exact: true,
		view: () => <CheckoutPackagePage />,
		access: "schedule"
	},
	{
		path: "/confirmation/:id",
		exact: true,
		view: () => <ConfirmationPage />,
		access: "schedule"
	},
	{
		path: "/confirmation/:id/bookingTransactionId/:bookingTransactionId",
		exact: true,
		view: () => <ConfirmationPage />,
		access: "schedule"
	},
	{
		path: "/confirmation-package/:id",
		exact: true,
		view: () => <PackagePurchaseConfirmation />,
		access: "schedule"
	},
	{
		path: "/confirmation-package/:id/bookingTransactionId/:bookingTransactionId",
		exact: true,
		view: () => <PackagePurchaseConfirmation />,
		access: "schedule"
	},
	{
		path: "/appointment-summary/:id/bookingTransactionId/:bookingTransactionId",
		exact: true,
		view: () => <GoogleTranslateErrorBoundary><AppointmentSummaryScreen /></GoogleTranslateErrorBoundary>,
		access: "private"
	},
	{
		path: "/appointment-summary/:id/bookingTransactionId/:bookingTransactionId/bookingId/:bookingId",
		exact: true,
		view: () => <GoogleTranslateErrorBoundary><AppointmentSummaryScreen /></GoogleTranslateErrorBoundary>,
		access: "private"
	},
	{
		path: "/login",
		exact: true,
		view: () => <TelephonePage />,
		access: "public"
	},
	{
		path: "/login/options",
		exact: true,
		view: () => <OptionsLogin />,
		access: "public"
	},
	{
		path: "/login/code",
		exact: true,
		view: () => <CodePage />,
		access: "public"
	},
	{
		path: "/login/personal-information",
		exact: true,
		view: () => <PersonalInformationPage />,
		access: "private"
	},
	{
		path: "/login/personal-information-number",
		exact: true,
		view: () => <PersonalInformationNumber />,
		access: "private"
	},
	{
		path: "/login/email-sign-up",
		exact: true,
		view: () => <EmailSignUp />,
		access: "private"
	},
	{
		path: "/login/email-sign-in",
		exact: true,
		view: () => <EmailSignIn />,
		access: "private"
	},
	{
		path: "/not-found",
		exact: true,
		view: () => <NotFound />,
		access: "public"
	},
	{
		path: "/sem-reservas",
		exact: true,
		view: () => <NoReservationsLink />,
		access: "public"
	},
	{
		path: "/indicacoes",
		exact: true,
		view: () => <Indications />,
		access: "private"
	},

	{
		path: "/indicacoes/seus-ganhos",
		exact: true,
		view: () => <YourEarnings />,
		access: "private"
	},

	{
		path: "/indicacoes/suas-indicacoes",
		exact: true,
		view: () => <YourReferrals />,
		access: "private"
	},

	{
		path: "/indicacoes/como-funciona",
		exact: true,
		view: () => <HowIndicationsWork />,
		access: "private"
	},
	{
		path: "/robots.txt",
		exact: true,
		view: () => <></>,
		access: "public"
	},
	{
		path: "/sitemap.xml",
		exact: true,
		view: () => <></>,
		access: "public"
	},
	{
    	path: "/link-expirado",
    	exact: true,
    	view: () => <ExpiredLink />,
		access: "public"
    },
];

export default routes;
